import axios from 'axios';
import http from '@/utils/http';
import {
    user,
    cash,
    teacherInfo,
    weekcard,
    studyreport,
    poster,
    shareCardActivity,
    shareActivity,
    logReport,
    phaseStudyReport,
    miniapp,
    miniCoursePackage,
    mall,
    home,
    campClass,
    campReport,
    h5Question,
    answer,
    evaluation,
    reserve,
    motivate
} from './constant';

let BASE_URL = '';
const isTest = ['test', 'testInlay', 'hotUpdate'].includes(process.env.VUE_APP_BUILD_ENV);

BASE_URL = isTest ? 'https://test-gx.feihua100.com' : 'https://gx.feihua100.com';
if (process.env.NODE_ENV === 'development') {
    BASE_URL = 'https://test-gx.feihua100.com';
}
// BASE_URL = 'https://gx.feihua100.com';
const GUSHI_BASE_URL = isTest ? 'https://test-api.feihua100.com' : 'https://api.feihua100.com';

export const getCouponDetail = params =>
    http.get(`${BASE_URL}/api/feihua/v1/coupon/info`, params);
export const getPayPageDetail = params =>
    http.get(`${BASE_URL}/api/feihua/v1/h5/pay/payPage`, params);


export const getStageDetail = params =>
    http.get(BASE_URL + phaseStudyReport.stageDetail, params);

export const getShareDetail = params =>
    http.get(BASE_URL + studyreport.shareDetail, params);

export const getShareDetail2 = params =>
    http.get(BASE_URL + miniapp.shareDetail2, params);

export const getWeekReport = params =>
    http.get(BASE_URL + miniapp.weekReport, params);

export const readFeedback = data =>
    http.qsPost(BASE_URL + studyreport.readFeedback, data);

export const getUserInfo = params =>
    http.get(BASE_URL + user.getUserInfo, params);

export const connectWechat = data =>
    http.qsPost(BASE_URL + user.connectWechat, data);

export const certificate = data =>
    http.qsPost(BASE_URL + user.certificate, data);

export const visitorBindPhoneSms = data =>
    http.qsPost(BASE_URL + user.visitorBindPhoneSms, data);

export const withdrawCheck = params =>
    http.get(BASE_URL + cash.withdrawCheck, params);

export const withdraw = data =>
    http.qsPost(BASE_URL + cash.withdraw, data);

export const upgrade = data =>
    http.qsPost(BASE_URL + cash.upgrade, data);

export const withdrawCreate = data =>
    http.qsPost(BASE_URL + cash.withdrawCreate, data);

export const entTeacherInfo = params =>
    http.get(BASE_URL + teacherInfo.entTeacherInfo, params);

export const viewRelationUp = params =>
    http.get(BASE_URL + weekcard.viewRelationUp, params);

export const wxAppLogin = data =>
    http.qsPost(BASE_URL + weekcard.wxAppLogin, data);

export const wxAppCodeToPhone = data =>
    http.qsPost(BASE_URL + weekcard.wxAppCodeToPhone, data);

export const bindPhoneWithoutCode = data =>
    http.qsPost(BASE_URL + weekcard.bindPhoneWithoutCode, data);

export const bindPhoneByUid = data =>
    http.qsPost(BASE_URL + weekcard.bindPhoneByUid, data);

export const receiveProRights = data =>
    http.qsPost(BASE_URL + weekcard.receiveProRights, data);

export const obtainCoupon = data =>
    http.qsPost(BASE_URL + weekcard.obtainCoupon, data);

export const sendMsgCode = data =>
    http.qsPost(BASE_URL + weekcard.sendMsgCode, data);

export const loginBySms = data =>
    http.qsPost(BASE_URL + weekcard.loginBySms, data);

export const getPosterList = params =>
    http.get(BASE_URL + poster.getPosterList, params);

export const getShareText = params =>
    http.get(BASE_URL + poster.getShareText, params);

export const shareReport = params =>
    http.get(BASE_URL + poster.shareReport, params);

export const joinShareCard = data =>
    http.qsPost(BASE_URL + shareCardActivity.joinShareCard, data);

export const joinInfo = params =>
    http.get(BASE_URL + shareCardActivity.joinInfo, params);

export const getSharePunchInfo = data =>
    http.qsPost(BASE_URL + shareActivity.sharePunchInfo, data);

export const getSharePunchInfoMiniApp = data =>
    http.qsPost(BASE_URL + shareActivity.sharePunchInfoMiniApp, data);

export const shareCardUp = data =>
    http.qsPost(BASE_URL + shareActivity.shareCardUp, data);

export const getOssToken = params =>
    http.get(BASE_URL + shareActivity.getOssToken, params);

export const shareImgUp = params =>
    http.get(BASE_URL + shareActivity.shareImgUp, params);

export const reportGetInviteQrCode = params =>
    http.get(BASE_URL + logReport.reportGetInviteQrCode, params);

export const courseList = data =>
    http.qsPost(BASE_URL + miniapp.courseList, data);

export const getMiniAppUserInfo = params =>
    http.get(BASE_URL + miniapp.getMiniAppUserInfo, params);

export const verifySession = params =>
    http.get(BASE_URL + miniapp.verifySession, params);

export const reportSession = data =>
    http.qsPost(BASE_URL + miniapp.reportSession, data);

export const resultSession = data =>
    http.qsPost(BASE_URL + miniapp.resultSession, data);

export const attendanceReport = data =>
    http.qsPost(BASE_URL + miniapp.attendanceReport, data);

export const learnReport = data =>
    http.qsPost(BASE_URL + miniapp.learnReport, data);

export const getUserInfoRead = params =>
    http.get(BASE_URL + user.getUserInfo, params);

export const loginRead = params =>
    http.get(BASE_URL + user.login, params);

export const certificateRead = data =>
    http.qsPost(BASE_URL + user.certificate, data);

export const withdrawCheckRead = params =>
    http.get(BASE_URL + cash.withdrawCheck, params);

export const withdrawRead = data =>
    http.qsPost(BASE_URL + cash.withdraw, data);

export const getHomeInfo = params =>
    http.get(BASE_URL + miniCoursePackage.home, params);

export const payRedeem = data =>
    http.qsPost(BASE_URL + miniCoursePackage.payRedeem, data);

export const getCourseInfo = params =>
    http.get(BASE_URL + miniCoursePackage.getCourseInfo, params);

export const catalog = params =>
    http.get(BASE_URL + miniCoursePackage.catalog, params);

export const levelList = params =>
    http.get(BASE_URL + miniCoursePackage.levelList, params);

export const switchCourseLevel = params =>
    http.get(BASE_URL + miniCoursePackage.switchCourseLevel, params);

export const payCreateOrder = data =>
    http.qsPost(BASE_URL + miniCoursePackage.createOrder, data);

export const getThirdPayQueryForQr = data =>
    http.qsPost(BASE_URL + miniCoursePackage.getThirdPayQueryForQr, data);

export const orderLoop = data =>
    http.qsPost(BASE_URL + miniCoursePackage.orderLoop, data);

export const orderList = data =>
    http.qsPost(BASE_URL + user.orderList, data);

export const orderDetail = params =>
    http.get(BASE_URL + user.orderDetail, params);

export const recordList = params =>
    http.get(BASE_URL + user.recordList, params);

export const combinationInfo = params =>
    http.get(BASE_URL + mall.combinationInfo, params);

export const openCombinationRight = data =>
    http.qsPost(BASE_URL + mall.openCombinationRight, data);

export const giftList = params =>
    http.get(BASE_URL + mall.giftList, params);

export const giftInfoById = params =>
    http.get(BASE_URL + mall.giftInfoById, params);

export const levelInfo = params =>
    http.get(BASE_URL + mall.levelInfo, params);

export const createOrder = params =>
    http.qsPost(BASE_URL + mall.createOrder, params);

export const miniappIndex = params =>
    http.get(BASE_URL + mall.miniappIndex, params);

// 礼品兑换详情
export const giftDetail = params =>
    http.get(BASE_URL + mall.giftDetail, params);

// 用户收货信息列表
export const logisticInfoListApi = params =>
    http.get(BASE_URL + mall.logisticInfoListApi, params);

// 用户收货信息列表
export const logisticInfoDetailApi = params =>
    http.get(BASE_URL + mall.logisticInfoDetailApi, params);

export const deliveryModifyApi = data =>
    http.qsPost(BASE_URL + mall.deliveryModifyApi, data);

export const logisticInfoUpdateApi = data =>
    http.qsPost(BASE_URL + mall.logisticInfoUpdateApi, data);

export const logisticInfoAddApi = data =>
    http.qsPost(BASE_URL + mall.logisticInfoAddApi, data);

export const redeemCollectApi = data =>
    http.qsPost(BASE_URL + mall.redeemCollectApi, data);

export const areaListApi = params =>
    http.get(BASE_URL + mall.areaListApi, params);

export const getCourseInfoJsonApi = (jsonUrl, data) =>
    http.get(jsonUrl, data, {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            'Authorization': 'mpweb',
        },
    });

// 发现页-精选内容
export const homeData = params =>
    http.get(BASE_URL + home.homeData, params);

// 学习页
export const learnPageData = params =>
    http.get(BASE_URL + home.learnPageData, params);

// 我的页
export const myPageData = params =>
    http.get(BASE_URL + home.myPageData, params);


export const getPub = data =>
    http.qsPost(BASE_URL + home.getPub, data);


// 营课相关
// 营课获取信息接口
export const joinClassInfo = data =>
    http.get(BASE_URL + campClass.joinClassInfo, data);
// 营课报名接口
export const campAttend = data =>
    http.qsPost(BASE_URL + campClass.campAttend, data);
// 微信code吗登录
export const wxH5Login = data =>
    http.qsPost(BASE_URL + campClass.wxH5Login, data);
// 绑定手机号
export const bindPhoneByUnionId = data =>
    http.qsPost(BASE_URL + campClass.bindPhoneByUnionId, data);
// 跳转小程序——获取小程序 urlLink 跳转链接
export const getMpUrlLink = data =>
    http.get(GUSHI_BASE_URL + campClass.getMpUrlLink, data);
// 获取老师图片
export const getWechatAccount = data =>
    http.get(BASE_URL + campClass.getWechatAccount, data);
export const getUserJoinInfo = data =>
    http.get(BASE_URL + campClass.userJoinInfo, data);
// 结营报告
// 获取结营报告详情
export const getCampReportDetail = params =>
    http.get(BASE_URL + campReport.getCampReportDetail, params);
// 结营体验课评价
export const campReportEvaluate = data =>
    http.qsPost(BASE_URL + campReport.campReportEvaluate, data);
// 获取作业批改结果详情
export const getHomeworkResultDetail = params =>
    http.get(BASE_URL + campReport.getHomeworkResultDetail, params);

// 体验课预约相关接口
// 小班直播课预约H5登录接口
export const login = data =>
    http.qsPost(BASE_URL + user.login, data);
// 获取预约小班直播课信息接口
export const reservationList = params =>
    http.get(BASE_URL + user.reservationList, params);
// 小班直播课预约接口
export const reservationStatus = data =>
    http.qsPost(BASE_URL + user.reservationStatus, data);

// H5题目 - 获取题目数据
export const getQuestionDetail = params =>
    http.get(BASE_URL + h5Question.getQuestionDetail, params);

// 获取预约小班直播课信息接口
export const sysReservationSysInfo = params =>
    http.get(BASE_URL + user.sysReservationSysInfo, params);
// 小班直播课预约接口
export const sysReservationStatus = data =>
    http.qsPost(BASE_URL + user.sysReservationStatus, data);

// 参考答案
export const referenceAnswerList = params =>
    http.get(BASE_URL + answer.referenceAnswerList, params);

export const bookList = params =>
    http.get(BASE_URL + answer.bookList, params);

// 英语随材——答案页码列表
export const answerPageList = params =>
    http.get(BASE_URL + answer.answerPageList, params);
// 英语随材——答案页详情
export const answerPageDetail = params =>
    http.get(BASE_URL + answer.answerPageDetail, params);
// 英语随材——专辑音频列表
export const audioList = params =>
    http.get(BASE_URL + answer.audioList, params);

// 测评 - 获取测评题目json
export const getEvaluationQuestionJson = params =>
    http.get(BASE_URL + evaluation.getEvaluationQuestionJson, params);
// 测评 - 上报测评结果
export const reportEvaluationResult = data =>
    http.qsPost(BASE_URL + evaluation.reportEvaluationResult, data);
// 测评 - 获取测评报告数据
export const getEvaluationReport = params =>
    http.get(BASE_URL + evaluation.getEvaluationReport, params);

export const getTimer = () => axios({
    url: `${BASE_URL + campClass.joinClassInfo}`,
    headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Authorization': 'mpweb'
    }
}).then(res => res.time * 1000);

// 【英语】获取预约小班直播课信息列表接口
export const reservationEnList = params =>
    http.get(BASE_URL + user.reservationEnList, params);
export const reservationoldEnInfo = params =>
    http.get(BASE_URL + user.reservationoldEnInfo, params);

// 【英语】小班直播课预约接口——体验课
export const reservationEnInfo = params =>
    http.get(BASE_URL + user.reservationEnInfo, params);
export const reservationEnStatus = data =>
    http.qsPost(BASE_URL + user.reservationEnStatus, data);

// 【英语】小班直播课预约接口——正价课
export const sysReservationEnSysInfo = params =>
    http.get(BASE_URL + user.sysReservationEnSysInfo, params);
export const sysReservationEnSysStatus = data =>
    http.qsPost(BASE_URL + user.sysReservationEnSysStatus, data);

// 【英语/阅读】小班直播课【重新预约】接口——体验课/正价课
export const reserveAgainInfo = params =>
    http.get(BASE_URL + user.reserveAgainInfo, params);
export const reserveAgainStatus = params =>
    http.get(BASE_URL + user.reserveAgainStatus, params);
export const reserveAgainInfoV2 = params =>
    http.get(BASE_URL + user.reserveAgainInfoV2, params);

// 新预约页 信息获取结构
export const reserveNewInfo = params =>
    http.get(BASE_URL + reserve.reserveNewInfo, params);
// 新预约页 预约接口
export const reserveNewStatus = data =>
    http.qsPost(BASE_URL + reserve.reserveNewStatus, data);


// 领课+白名单接口
export const leadClass = data =>
    http.get(BASE_URL + user.leadClass, data);

// H5题目 - 获取 prompt 交互 gpt 的结果，语音流交互(AI提示、AI点评)
export const getAudioReplyAi = data =>
    http.fetchPost(BASE_URL + h5Question.getAudioReplyAi, data);

// H5题目 - 获取prompt模版信息
export const getPromptTemplateApi = params =>
    http.get(BASE_URL + h5Question.getPromptTemplateApi, params);

// 获取激励页信息
export const getMotivateInfo = params =>
    http.get(BASE_URL + motivate.getMotivateInfo, params);

// 兑换
export const purchaseEnergy = params =>
    http.qsPost(BASE_URL + motivate.purchaseEnergy, params);

// 充能
export const charge = params =>
    http.qsPost(BASE_URL + motivate.charge, params);

// 升阶
export const levelUp = params =>
    http.qsPost(BASE_URL + motivate.levelUp, params);
